(function(){
'use strict';
var d=document,w=window;
var asides=[].slice.call(d.querySelectorAll('.art-aside'));if(!asides.length)return;
var TOP=118,tk=false,cur=[],tgt=[];
asides.forEach(function(a,i){cur[i]=0;tgt[i]=0;});
function on(){return w.innerWidth>=1200;}
function calc(){tk=false;
asides.forEach(function(a,i){var inn=a.querySelector('.art-aside__in');if(!inn)return;
if(!on()){tgt[i]=0;return;}
var ar=a.getBoundingClientRect(),ih=inn.offsetHeight,ah=a.offsetHeight,max=Math.max(0,ah-ih),vh=w.innerHeight,off;
if(ih<=vh-TOP-24){off=TOP-ar.top;}
else{var span=Math.max(1,ah-vh);off=(-ar.top/span)*max;}
tgt[i]=Math.max(0,Math.min(max,off));});
if(!raf)raf=requestAnimationFrame(step);}
var raf=0;
function step(){raf=0;var more=false;
asides.forEach(function(a,i){var inn=a.querySelector('.art-aside__in');if(!inn)return;var dlt=tgt[i]-cur[i];if(Math.abs(dlt)>.4){cur[i]+=dlt*.16;more=true;}else cur[i]=tgt[i];inn.style.transform='translate3d(0,'+cur[i].toFixed(1)+'px,0)';});
if(more)raf=requestAnimationFrame(step);}
function req(){if(!tk){tk=true;requestAnimationFrame(calc);}}
w.addEventListener('scroll',req,{passive:true});w.addEventListener('resize',req);w.addEventListener('load',req);
if(w.ResizeObserver){var ro=new ResizeObserver(req);asides.forEach(function(a){ro.observe(a);});}
calc();
})();
